import * as yup from "yup";

export const orderReportClientValidationSchema = (reportValidationSchema: any) =>  yup.object().shape({
    createdFrom: yup.string().required(reportValidationSchema.selectDate),
    createdTo: yup.string().required(reportValidationSchema.selectDate),
    currentStatus: yup.string().required(reportValidationSchema.selectStatus),
    orderBy: yup.string().required(reportValidationSchema.selectColumn),
    desc: yup.string().required(reportValidationSchema.selectDirection),
  });